import { Directive, Input, TemplateRef, ViewContainerRef, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { fromEvent, Subject } from 'rxjs';

@Directive({
  selector: '[unhIfMedia]'
})
export class IfMediaDirective implements AfterViewInit, OnDestroy {
  private readonly destroy$ = new Subject();

  @Input() unhIfMedia: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.doMediaMatching(this.unhIfMedia);

    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.doMediaMatching(this.unhIfMedia));
  }

  doMediaMatching(rules: string) {
    const mq = window.matchMedia(rules);
    if (mq.matches) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
